import { Container } from "./styles";
import { BrowserRouter as Router } from "react-router-dom";
import { NavHashLink, HashLink } from "react-router-hash-link";
import { useState, useEffect } from "react";

// import CV from "../../assets/KirtiKamal.pdf";
export function Header() {
  const [isActive, setActive] = useState(false);
  const [activeSection, setActiveSection] = useState("home");

  function closeMenu() {
    setActive(false);
  }

  useEffect(() => {
    const sections = ["home", "about", "expertise", "experience", "project", "contact"];
    
    const observerOptions = {
      root: null,
      rootMargin: "-20% 0px -70% 0px",
      threshold: 0
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveSection(entry.target.id);
        }
      });
    }, observerOptions);

    sections.forEach((section) => {
      const element = document.getElementById(section);
      if (element) {
        observer.observe(element);
      }
    });

    return () => {
      sections.forEach((section) => {
        const element = document.getElementById(section);
        if (element) {
          observer.unobserve(element);
        }
      });
    };
  }, []);

  return (
    <Container className="header-fixed">
      <Router>
        <HashLink smooth to="#home" className="logo">
          <span>Kirti </span>
          <span>Kamal</span>
        </HashLink>

        <nav className={isActive ? "active" : ""}>
          <NavHashLink 
            smooth 
            to="#home" 
            onClick={closeMenu}
            className={activeSection === "home" ? "active-link" : ""}
          >
            Home
          </NavHashLink>
          <NavHashLink 
            smooth 
            to="#about" 
            onClick={closeMenu}
            className={activeSection === "about" ? "active-link" : ""}
          >
            About me
          </NavHashLink>
          <NavHashLink 
            smooth 
            to="#expertise" 
            onClick={closeMenu}
            className={activeSection === "expertise" ? "active-link" : ""}
          >
            Expertise
          </NavHashLink>
          <NavHashLink 
            smooth 
            to="#experience" 
            onClick={closeMenu}
            className={activeSection === "experience" ? "active-link" : ""}
          >
            Experience
          </NavHashLink>
          <NavHashLink 
            smooth 
            to="#project" 
            onClick={closeMenu}
            className={activeSection === "project" ? "active-link" : ""}
          >
            Project
          </NavHashLink>
          <NavHashLink 
            smooth 
            to="#contact" 
            onClick={closeMenu}
            className={activeSection === "contact" ? "active-link" : ""}
          >
            Contact
          </NavHashLink>

          <a
            href="https://decodedevs.hashnode.dev"
            target="_blank"
            rel="noopener noreferrer"
          >
            Blogs
          </a>
{/* 
          <a href={"#"} download className="button">
            Resume
          </a> */}
        </nav>

        <div
          aria-expanded={isActive ? "true" : "false"}
          aria-haspopup="true"
          aria-label={isActive ? "Fechar menu" : "Abrir menu"}
          className={isActive ? "menu active" : "menu"}
          onClick={() => {
            setActive(!isActive);
          }}
        ></div>
      </Router>
    </Container>
  );
}
